export default __webpack_public_path__ + "static/media/Z_wdt_c_cap_2.2921d486.mp3";